enum ToastContainerPosition {
   Absolute = 'PositionAbsolute',
   Static = 'PositionStatic',
   Fixed = 'PositionFixed',
   Relative = 'PositionRelative',
}

export const ToastContainerPositionValuesMap = {
   [ToastContainerPosition.Absolute]: 'position-absolute',
   [ToastContainerPosition.Static]: 'position-static',
   [ToastContainerPosition.Fixed]: 'position-fixed',
   [ToastContainerPosition.Relative]: 'position-relative',
};

enum ToastPlacement {
   TopLeft = 'TopLeft',
   TopMiddle = 'TopMiddle',
   TopRight = 'TopRight',
   BottomLeft = 'BottomLeft',
   BottomMiddle = 'BottomMiddle',
   BottomRight = 'BottomRight',
}

export const ToastPlacementValuesMap = {
   [ToastPlacement.TopLeft]: 'placement-top-left',
   [ToastPlacement.TopMiddle]: 'placement-top-middle',
   [ToastPlacement.TopRight]: 'placement-top-right',
   [ToastPlacement.BottomLeft]: 'placement-bottom-left',
   [ToastPlacement.BottomMiddle]: 'placement-bottom-middle',
   [ToastPlacement.BottomRight]: 'placement-bottom-right',
};

enum ToastVariant {
   Primary = 'Primary',
   Secondary = 'Secondary',
   Success = 'Success',
   Warning = 'Warning',
   Danger = 'Danger',
   PrimaryBordered = 'PrimaryBordered',
   SecondaryBordered = 'SecondaryBordered',
   SuccessBordered = 'SuccessBordered',
   WarningBordered = 'WarningBordered',
   DangerBordered = 'DangerBordered',
   Light = 'Light',
   Dark = 'Dark',
}

export const ToastVariantValuesMap = {
   [ToastVariant.Primary]: 'primary',
   [ToastVariant.Secondary]: 'secondary',
   [ToastVariant.Success]: 'success',
   [ToastVariant.Warning]: 'warning',
   [ToastVariant.Danger]: 'danger',
   [ToastVariant.Dark]: 'dark',
   [ToastVariant.PrimaryBordered]: 'primary-bordered',
   [ToastVariant.SecondaryBordered]: 'secondary-bordered',
   [ToastVariant.SuccessBordered]: 'success-bordered',
   [ToastVariant.WarningBordered]: 'warning-bordered',
   [ToastVariant.DangerBordered]: 'danger-bordered',
   [ToastVariant.Light]: 'light',
};

export const ToastVariantIconsMap = {
   [ToastVariant.Primary]: undefined,
   [ToastVariant.Secondary]: undefined,
   [ToastVariant.Success]: undefined,
   [ToastVariant.Warning]: undefined,
   [ToastVariant.Danger]: undefined,
   [ToastVariant.Dark]: undefined,
   [ToastVariant.PrimaryBordered]: 'circle-info atl-toast-icon primary',
   [ToastVariant.SecondaryBordered]: 'message atl-toast-icon secondary',
   [ToastVariant.SuccessBordered]: 'circle-check atl-toast-icon success',
   [ToastVariant.WarningBordered]:
      'triangle-exclamation atl-toast-icon warning',
   [ToastVariant.DangerBordered]: 'triangle-exclamation atl-toast-icon danger',
   [ToastVariant.Light]: undefined,
};

export { ToastPlacement, ToastContainerPosition, ToastVariant };
